import React, { useState, useEffect, useRef } from "react";
import { Button } from "rsuite";
import { numberFormatter, numberFormatterInK } from "../../utils";
import ParametricMaterialTable from "./parametricMaterialTable";
import ParametricScatter from "./parametricScatter";
import { CSVLink, CSVDownload } from "react-csv";
import ParametricSupplierTable from "./parametricSupplierTable";
import FileDownloadIcon from "@rsuite/icons/FileDownload";

const CostReduction = (props: any) => {
	const { materialExportData } = props;

	const supplierData = props.data;
	const materialData = props.materialData;
	const scatterData = props.scatterData;
	const materialCount = props.materialCount;

	const exportFullRef = useRef<any>(null);

	const [scatter, setScatter] = useState<any>([]);

	const csvHeaders = [
		{ label: "Material Number", key: "MaterialNumber" },
		{ label: new Date().getFullYear() + " Spend", key: "ThisYear_Spend" },
		{ label: "Actual Unit Cost", key: "actualUnitCost" },
		{ label: "Modelled Unit Price", key: "modelledUnitPrice" },
		{ label: "% Cost Reduction", key: "costReduction" },
		{ label: "Benefit", key: "benifit" },
	];

	console.log("******MATERIAL*****", materialData);

	const validateNumbers = (e: any) => {
		return (e.target.value = e.target.value.replace(/[^\d]/g, ""));
	};

	const exportExcel = () => {
		props.getMaterialData();
	};

	useEffect(() => {
		if (materialExportData?.length !== 0) {
			exportFullRef?.current?.link.click();
		}
	}, [materialExportData]);

	useEffect(() => {
		if (props?.scatterData?.data?.length > 0) {
			let maxValue = props.scatterData?.data?.reduce(
				(acc: any, value: any) => {
					return (acc =
						acc > value.actualUnitCost
							? acc
							: value.actualUnitCost);
				},
				0
			);

			let newData: any = [];

			props?.scatterData?.data.map((item: any, index: any) => {
				if (maxValue > 700) {
					if (item.actualUnitCost < 700) {
						newData.push(item);
					}
				} else {
					if (
						item.actualUnitCost < 20 &&
						item.modelledUnitPrice < 12
					) {
						newData.push(item);
					}
				}
			});

			setScatter(newData);
		}
	}, [props.scatterData]);

	return (
		<>
			<div className="topSuppliers-container flex flex-col justify-start gap-y-[1vh] overflow-x-auto">
				{props.selectedFilters?.l4?.length > 0 ? (
					<>
						<div className="grow-1 h-full">
							{props.selectedSupplier === null ? (
								<ParametricSupplierTable
									updateSupplier={(supplier: any) => {
										props.updateSelectedSupplier(supplier);
									}}
									data={supplierData}
								/>
							) : (
								<ParametricMaterialTable
									data={materialData}
									count={materialCount}
									updatePageNumber={(page: any) => {
										props.updatePageNumber(page);
									}}
									pageNumber={props.pageNumber}
								/>
							)}
						</div>
					</>
				) : (
					<div className="msg-container h-full flex justify-center items-center italic ">
						<span className="text-center text-black text-[2.5vh]">
							Please select the L4 category to see the relevant
							attributes
						</span>
					</div>
				)}
			</div>

			<div className="spendConsolidation-container flex flex-col gap-y-[0.5vh] overflow-x-auto">
				{props?.tableLoading ? (
					<div className="loaderCustom"></div>
				) : props.selectedSupplier !== null ? (
					<>
						<div className="h-[20vh]">
							<div className="flex justify-end mt-3 mr-3">
								<div className="flex items-center">
									<div className="w-2 h-2 rounded-full border-4 border-[#FF9601]"></div>
									<p className="text-0.7vw pl-1 text-black">
										{" "}
										Higher than expected price
									</p>
								</div>

								<div className="flex items-center pl-2">
									<div className="w-2 h-2 rounded-full border-4 border-[#056FAD]"></div>
									<p className="text-0.7vw pl-1 text-black">
										{" "}
										Lower than expected price
									</p>
								</div>
								<div
									className="submitButton flex items-center pl-2 cursor-pointer"
									onClick={exportExcel}
								>
									<FileDownloadIcon
										color="black"
										className="text-fsre15"
									/>
									<CSVLink
										ref={exportFullRef}
										data={materialExportData}
										headers={csvHeaders}
										filename="material.csv"
										className="hidden"
										target="_blank"
									>
										{" "}
									</CSVLink>
								</div>
							</div>

							<div className="flex gap-4 mx-[2vh] my-[1vh]">
								<div className="customcard flex flex-col items-start  p-[1vh] rounded-sm">
									<span className="font-bold text-[1.5vh] text-[#666]">
										Total Benefit
									</span>

									<div className="px-[1vh] py-[1vh] font-bold italic text-black w-[8vw] ">
										{numberFormatter(
											scatterData.totalBenifit,
											0,
											"$"
										)}
									</div>
								</div>

								<div className="customcard flex flex-col items-start  p-[1vh] rounded-sm">
									<span className="font-bold text-[1.5vh] text-[#666]">
										Model Accuracy
									</span>

									<div className="px-[1vh] py-[1vh] font-bold italic text-black w-[8vw] ">
										{scatterData.modelAccuracy}%
									</div>
								</div>

								<div className="customcard flex flex-col items-start  p-[1vh] rounded-sm">
									<span className="font-bold text-[1.5vh] text-[#666]">
										Number of Attributes
									</span>

									<div className="px-[1vh] py-[1vh] font-bold italic text-black w-[8vw] ">
										{scatterData.noOfAttributes}
									</div>
								</div>
								<div className="customcard flex flex-col items-start  p-[1vh] rounded-sm">
									<span className="font-bold text-[1.5vh] text-[#666]">
										SKUs with Non-Optimal Prices
									</span>

									<div className="px-[1vh] py-[1vh] font-bold italic text-black w-[8vw] ">
										{scatterData.skuWnonOptimalPrices}
									</div>
								</div>
							</div>
						</div>
						<div className="flex flex-col h-[50vh] w-full items-center">
							<ParametricScatter
								// data={scatterData?.data}
								data={scatter}
							/>
							<p className="text-xs mt-[-10px] ml-[3vw] text-center">
								(size of the bubble to represent the spend){" "}
							</p>
						</div>
					</>
				) : (
					// </div>
					<div className="msg-container h-full flex justify-center items-center italic">
						<span className="text-center text-black text-[2.5vh]">
							Please select the L4 category to see the relevant
							attributes
						</span>
					</div>
				)}
			</div>
		</>
	);
};

export default CostReduction;
